import { api } from 'api';
import { user } from 'services';

/**
 * topup
 * @param {*} data
 * @returns
 */
export const updateClientsOpt = (data) => {
  return api.call('balance_settings.update', data);
};

export const getClientsOpt = () => {
  return api.call('balance_settings.list');
};
